/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: OnlineUser.ts
 * Created by: ChanYing
 * Create Date: 2022-11-23 09:35
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import {reactive} from "vue";
import {TeamInfoVO} from "@/mvc/models/team/TeamInfoVO";
import UserInfoVO from "@/mvc/models/team/UserInfoVO";

export class OnlineUser {

    public static readonly S_TeamInfo_TeamDomain: string = "sg-team-domain";

    private _userInfo: UserInfoVO;
    private _teamInfo: TeamInfoVO;

    constructor() {
        this._userInfo = reactive(new UserInfoVO());
        this._teamInfo = reactive(new TeamInfoVO());
    }

    public get userInfo(): UserInfoVO {
        return this._userInfo;
    }

    public set userInfo(value: any) {
        this._userInfo = reactive(value);
    }

    public get teamInfo(): TeamInfoVO {
        return this._teamInfo;
    }

    public set teamInfo(value: any) {
        this._teamInfo = reactive(value);
    }

    public reset(): void {
        this._userInfo = reactive(new UserInfoVO());
        this._teamInfo = reactive(new TeamInfoVO());
    }

    public isAuthorized(): boolean {
        return this.userInfo != null && this.userInfo.isValid()
            && this.teamInfo != null && this.teamInfo.isValid()
            ;
    }
}